export const EmailRecipientStatus = {
  QUEUED: 'queued',
  SENT: 'sent',
  DELIVERED: 'delivered',
  OPENED: 'opened',
  ERROR: 'error',
  CLICKED: 'clicked',
  SPAM: 'spam',
}
